/*
 * @Description:: 请补充填写
 * @Version: 1.0
 * @Author: smallWhite
 * @Date: 2023-03-20 20:49:33
 * @LastEditors: smallWhite
 * @LastEditTime: 2023-04-06 14:23:03
 * @FilePath: /chat_gpt/src/main.js
 */
// 兼容旧版 hash 链接：访问 /#/about 时自动重定向到 /about
(function () {
  const hash = window.location.hash
  if (hash && hash.startsWith('#/')) {
    let pathname = window.location.pathname || '/'
    const search = window.location.search || ''
    // 避免子目录部署时产生双斜杠，如 /testPage/ + /about => /testPage/about
    if (pathname.endsWith('/')) {
      pathname = pathname.slice(0, -1)
    }
    const newUrl = pathname + hash.replace('#', '') + search
    window.location.replace(newUrl)
  }
})()

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/css/style.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import 'element-ui/lib/theme-chalk/index.css'
import i18n from './i8n'
import { REQUEST } from '@/api/http'
import * as echarts from 'echarts'



import VueClipboard from 'vue-clipboard2';//引入复制功能插件

import VueTouch from 'vue-touch'  //引用移动端图片手指滑动

import VuePageTransition from 'vue-page-transition'  //从右到左滑动动画

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
Vue.use(VueTouch, {name:'v-touch'})
Vue.use(VuePageTransition)

Vue.use(ElementUI,
  {
    i18n:(key, value) => i18n.t(key, value)  //在注册Element 时设置i18n的处理方法，可以实现当点击切换按钮后，elementUi可以自动切换.js语言文件实现多语言切换
  }
)
Vue.use(VueClipboard)

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$https = REQUEST.POST
Vue.prototype.$httpsGET = REQUEST.GET
Vue.prototype.$httpsPOSTLINE = REQUEST.POST_LINE



new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
